(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('InvestorUpdateFactory', [
			'$q',
			'INVESTMENT_ENTITY_ID',
			'PropertyService',
			'urlFactory',
			investorUpdateServiceFunction
		]);

	function investorUpdateServiceFunction(
		$q,
		INVESTMENT_ENTITY_ID,
		PropertyService,
		urlFactory
	) {
		var factory = {
			getById: getById,
			getAssociatedUpdatesByReitElementId: getAssociatedUpdatesByReitElementId
		};

		return factory;

		function getById(investorUpdateId) {
			var deferred = $q.defer();

			var updateUrl;
			if (angular.isDefined(INVESTMENT_ENTITY_ID)) {
				updateUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investor-update/' + investorUpdateId;
			}
			else {
				updateUrl = '/api/investor-updates/' + investorUpdateId;
			}

			urlFactory.apiGetPromise(updateUrl)
				.then(function (response) {
					var update = response.data;
					if (angular.isDefined(update.reitElement)) {
						update.reitElement = PropertyService.formatPropertyListItem(update.reitElement);
					}
					deferred.resolve(update);
				}, function() {
					deferred.resolve(undefined);
				});

			return deferred.promise;
		}

		function getAssociatedUpdatesByReitElementId(reitElementId) {
			var updateUrl;

			if (angular.isDefined(INVESTMENT_ENTITY_ID)) {
				updateUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/reit-elements/' + reitElementId + '/investor-updates';
			} else {
				updateUrl = '/api/reit-elements/' + reitElementId + '/investor-updates';
			}

			return urlFactory.apiGetPromise(updateUrl)
				.then(function (response) {
					return response.data;
				});
		}
	}
})(window.angular);